import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class LandingPageGuard implements CanActivate {
  constructor(private readonly router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (route.queryParamMap.keys.length == 0) {
      return true;
    }

    this.router.navigate(['appointment'], { queryParams: route.queryParams });
    return false;
  }
}
